<template lang="pug">
  .c-bananas-widget(v-if='!noResults' v-scroll="scrollVisible")
    .c-bananas-widget__loop(v-for='flightList in flightResults' :class="{'c-bananas-widget--fade': !flightOfferLoading}" v-show='!flightOfferLoading')
      .c-offercard__wrapper(v-for='(tripset, index) in flightList.data.tripsets' :class="['js-offercard--' + tripset.id]" :data-track-id="tripset.id")
        .c-offercard
          img.c-offercard__image.c-offercard__image--flight(:src="backgroundImagePath")
          .c-offercard__info
            .c-offercard__price
              img.c-offercard__provider-image(:src="['https://s3.eu-central-1.amazonaws.com/tremo-web-assets/provider/flights/' + tripset.pricings[Object.keys(tripset.pricings)[0]].providers[0].name + '.png']")
              span.c-offercard__price-prefix {{ $t('text.pricefrom') }}
              span.c-offercard__price-currency(v-if="tripset.pricings[Object.keys(tripset.pricings)[0]].currency !== 'EUR'") {{$t('text.currency.' + tripset.pricings[Object.keys(tripset.pricings)[0]].currency)}}
              span.c-offercard__price-value {{ tripset.pricings[Object.keys(tripset.pricings)[0]].amount | formatPrice }}
              span.c-offercard__price-currency(v-if="tripset.pricings[Object.keys(tripset.pricings)[0]].currency === 'EUR'") {{$t('text.currency.' + tripset.pricings[Object.keys(tripset.pricings)[0]].currency)}}
            .c-offercard__category
              img.c-offercard__category-icon(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/flights.svg')
              .c-offercard__headline
                | {{ $t('headline.flight.returnflightto') }} {{ flightList.data.airports[tripset.out_dest].locale_city }} {{ $t('headline.flight.fromorigin') }}&nbsp;
                span.c-offercard__action-link(v-if='editable' @click='toggleAutocomplete') {{ originAirport }}
                span(v-else) {{ originAirport }}
            .c-bnflightlist-offer__wrapper
              .c-bnflightlist-offer__flight-infodata
                .c-bnflightlist-offer__icon
                  span {{ $t("text.flight.outward") }}
                .c-bnflightlist-offer__flight-airport
                  span <b>{{ flightList.data.airports[tripset.out_orig].locale_city }}</b> ({{ tripset.out_orig }})
                  span <b>{{ flightList.data.airports[tripset.out_dest].locale_city }}</b> ({{ tripset.out_dest }})
                .c-bnflightlist-offer__flight-timeline
                  span {{ [tripset.out_dep_airport, timeFormat] | formatTime}}
                  .c-bnflightlist-offer__flight-timeline-airlines
                    .c-bnflightlist-offer__flight-airline(v-for='leg in flightList.data.portions[tripset.portions[0]].legs')
                      .c-bnflightlist-offer__pause
                  span {{ [tripset.out_arr_airport, timeFormat] | formatTime}}
                .c-bnflightlist-offer__flight-date
                  span {{ [tripset.out_dep_airport, dateFormat] | formatDate }}
                  .c-flight__duration {{ flightList.data.portions[tripset.portions[0]].duration | calculateTravelTime }}
                    span(v-if='flightList.data.portions[tripset.portions[0]].leg_count > 1') , {{ flightList.data.portions[tripset.portions[0]].leg_count - 1  }} {{ $t("text.flightstop.other") }}
                    span(v-else) , {{$t('text.flight.direct')}}
                  span {{ [tripset.out_arr_airport, dateFormat] | formatDate }}
            hr.c-offercard-horizontal-line
            .c-bnflightlist-offer__wrapper
              .c-bnflightlist-offer__flight-infodata
                .c-bnflightlist-offer__icon(class="reverse")
                  span {{ $t('text.flight.returnflight') }}
                .c-bnflightlist-offer__flight-airport
                  span <b>{{ flightList.data.airports[tripset.in_orig].locale_city }}</b> ({{ tripset.in_orig }})
                  span <b>{{ flightList.data.airports[tripset.in_dest].locale_city }}</b> ({{ tripset.in_dest }})
                .c-bnflightlist-offer__flight-timeline
                  span {{ [tripset.in_dep_airport, timeFormat] | formatTime}}
                  .c-bnflightlist-offer__flight-timeline-airlines
                    .c-bnflightlist-offer__flight-airline(v-for='leg in flightList.data.portions[tripset.portions[1]].legs')
                      .c-bnflightlist-offer__pause
                  span {{ [tripset.in_arr_airport, timeFormat] | formatTime}}
                .c-bnflightlist-offer__flight-date
                  span {{ [tripset.in_dep_airport, dateFormat] | formatDate }}
                  .c-flight__duration {{ flightList.data.portions[tripset.portions[1]].duration | calculateTravelTime }}
                    span(v-if='flightList.data.portions[tripset.portions[1]].leg_count > 1') , {{ flightList.data.portions[tripset.portions[1]].leg_count - 1  }} {{ $t("text.flightstop.other") }}
                    span(v-else) , {{ $t('text.flight.direct') }}
                  span {{ [tripset.in_arr_airport, dateFormat] | formatDate }}
          .c-offercard__button
            form(action="https://rdr.holidaypirates.group/v1/link" :target="setRedirectTarget()" method="post")
              input(type="hidden" name="config[redirect]" value="true")
              input(type="hidden" name="data[url][encoding]" value="base64_url")
              input(type="hidden" name="data[url][url]" :value="base64EncodeUnicode(flightList.config.baseurl + tripset.pricings[Object.keys(tripset.pricings)[0]].providers[0].link)")
              input.c-btn.c-btn--function.c-offercard__button-link(:value='$t("button.flight")' type="submit" @click='clickOut')
        .c-offercard__autocomplete(:class="{'c-offercard__autocomplete-open': autoCompleteOpen}" v-show='!flightOfferLoading')
          span.c-offercard__autocomplete-close
          .c-offercard__autocomplete--group
            label.c-offercard__autocomplete--label {{ $t('label.changeorigin') }}
            Multiselect(
              v-model="selectedAirports",
              :options="flightDestinations",
              :multiple="multiple",
              :searchable="searchable",
              @search-change="searchForFlightDestinations",
              @select="onSelect",
              :placeholder="$t('placeholder.changeorigin')",
              :custom-label="customLabel",
              :show-labels="false"
            )
              span(slot="noResult").
                {{ $t('text.changeorigin.noresultsautocomplete') }}
              span(slot="noOptions").
                {{ $t('text.changeorigin.mincharacters') }}
              template(slot="singleLabel", slot-scope="props")
                span.option__title {{ props.option.name }}
                span(v-if="props.option.type === 'airport'") &nbsp;({{ props.option.values.iata }})
              template(slot="option", slot-scope="props")
                span.option__title {{ props.option.name }}
                span(v-if="props.option.type === 'airport'") &nbsp;({{ props.option.values.iata }})
          span.c-btn.c-btn--function.c-offercard__success-btn(@click='updateFlightOffer') {{ $t('button.changeorigin') }}
    .c-hightlights--loading(v-show='flightOfferLoading')
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
  .c-bananas-widget__empty(v-else)
    .c-offercard__no-results
      p.c-offercard__no-results-headline {{ $t('text.changeorigin.noresults') }}
      img(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/img/no-results.png')
      p.c-offercard__no-results-text {{ $t('text.changeorigin.alternative') }}
      ul.c-offercard__no-results-alternative-list
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Frankfurt/Main", values: {iata: "FRA"}})') Frankfurt/Main
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Berlin (alle Flughäfen)", values: { iata: "BER"}})') Berlin (alle Flughäfen)
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "München", values: { iata: "MUC"}})') München
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Düsseldorf", values: { iata: "DUS"}})') Düsseldorf
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Hamburg", values: { iata: "HAM"}})') Hamburg
</template>

<script>
import fecha from 'fecha'
import dbActions from '../api/dbactions'
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import flightSchema from '@/utils/schemas/flight.js'
import flightSetup from '@/settings/flightSetup'

export default {
  name: 'FlightTeaser',
  data() {
    return {
      backgroundImagePath: '',
      autoCompleteOpen: false,
      multiple: false,
      searchable: true,
      selectedAirports: [],
      flightDestinations: [],
      originAirport: '',
      flightOfferLoading: false,
      userSelection: [],
      flightResults: this.flightLists,
      noResults: false,
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  props: [
    'flightLists',
    'dateFormat',
    'timeFormat',
    'departureAirportName',
    'arrivalAirportName',
    'editable'
  ],
  components: {
    Multiselect
  },
  created() {
    this.backgroundImagePath =
      'https://tremo-web-assets.s3.eu-central-1.amazonaws.com/img/bananas-flight-teaser.jpg'
    this.originAirport = this.flightResults[0].data.airports[
      this.flightResults[0].data.tripsets[
        Object.keys(this.flightResults[0].data.tripsets)[0]
      ].out_orig
    ].locale_city
    /*
    if (this.flightLists !== null) {
      this.backgroundImagePath = this.getImage(
        [
          this.flightResults[0].data.airports[
            this.flightResults[0].data.tripsets[
              Object.keys(this.flightResults[0].data.tripsets)[0]
            ].in_orig
          ].lon,
          this.flightResults[0].data.airports[
            this.flightResults[0].data.tripsets[
              Object.keys(this.flightResults[0].data.tripsets)[0]
            ].in_orig
          ].lat
        ],
        [
          this.flightResults[0].data.airports[
            this.flightResults[0].data.tripsets[
              Object.keys(this.flightResults[0].data.tripsets)[0]
            ].in_dest
          ].lon,
          this.flightResults[0].data.airports[
            this.flightResults[0].data.tripsets[
              Object.keys(this.flightResults[0].data.tripsets)[0]
            ].in_dest
          ].lat
        ]
      )
      this.originAirport = this.flightResults[0].data.airports[
        this.flightResults[0].data.tripsets[
          Object.keys(this.flightResults[0].data.tripsets)[0]
        ].out_orig
      ].locale_city
      let iata = this.flightResults[0].data.airports[
        this.flightResults[0].data.tripsets[
          Object.keys(this.flightResults[0].data.tripsets)[0]
        ].out_orig
      ].iata
      if (iata === '') {
        iata = this.flightResults[0].data.airports[
          this.flightResults[0].data.tripsets[
            Object.keys(this.flightResults[0].data.tripsets)[0]
          ].out_orig
        ].iata_city
      }
      this.selectedAirports = [
        {
          name: this.originAirport,
          values: {
            iata: iata
          }
        }
      ]
      this.userSelection = [iata]
    }
    */
  },
  mounted() {
    this.scrollVisible()
  },
  methods: {
    clickOut() {
      // Track clickOut
      let actionData = {
        url:
          window.location.protocol +
          '//' +
          window.location.host +
          '/' +
          window.location.pathname,
        language: this.$store.getters.getLocale,
        type: 'clickOut',
        vertical: 'flight',
        unique: this.$store.getters.getUniqueClickOut
      }
      this.$store.dispatch('updateUniqueClickOut')
      if (this.$store.getters.getTrackingIsAllowed) {
        dbActions.trackAction(actionData, this)
      }
      this.trackClick()
    },
    setRedirectTarget() {
      if (this.$store.getters.getInAppBrowser) {
        return '_self'
      }
      return '_blank'
    },
    getImage(pointFrom, pointTo) {
      let geoJson = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: pointFrom
            },
            properties: {
              'marker-url':
                'https://s3.eu-central-1.amazonaws.com/tremo-web-assets/map/map-marker-location-land.png'
            }
          },
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: pointTo
            },
            properties: {
              'marker-url':
                'https://s3.eu-central-1.amazonaws.com/tremo-web-assets/map/map-marker-location-takeoff.png'
            }
          },
          {
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: [pointFrom, pointTo]
            },
            properties: {
              stroke: '#6A3460',
              'stroke-width': '1'
            }
          }
        ]
      }
      let teaserImageWidth = 420
      if (window.screen.width < 420) {
        teaserImageWidth = window.screen.width
      }
      return (
        'https://travelpirates-middleware.holidaypirates.group/assets/static-map?geojson=' +
        encodeURIComponent(JSON.stringify(geoJson)) +
        '&width=' +
        teaserImageWidth +
        '&height=200&language=de'
      )
    },
    toggleAutocomplete() {
      this.autoCompleteOpen = !this.autoCompleteOpen
    },
    searchForFlightDestinations(query) {
      let vm = this
      if (query.length > 1) {
        axios
          .get(
            'https://autocomplete.holidaypirates.group/v1/suggest?data[term]=' +
              query +
              '&data[filters][types]=&config[target]=dest&config[type]=kiwi&config[source]=123&config[language]=' +
              this.$store.getters.getLocaleShort
          )
          .then(function(response) {
            vm.flightDestinations = []
            response.data.data.results.forEach(object => {
              vm.flightDestinations.push(object)
            })
          })
      }
    },
    onSelect(option, id) {
      this.originAirport = option.name
      const originValues = option.values.payload.split('_')
      this.userSelection = [
        {
          type: originValues[0],
          value: originValues[1]
        }
      ]
    },
    updateFlightOffer() {
      let vm = this
      vm.autoCompleteOpen = !vm.autoCompleteOpen
      // Set offer to loading
      vm.flightOfferLoading = true
      // Search for offer
      let flightSearchObject = flightSetup
      flightSearchObject.language = this.$store.getters.getLocaleShort.toLowerCase()
      flightSearchObject.departureAirport = vm.userSelection
      let flightData = flightSchema.setReturnFlightSchema(flightSearchObject)
      axios
        .post('https://cn.holidaypirates.group/v1.1/search', flightData, {
          headers: ''
        })
        .then(function(response) {
          vm.flightResults = []
          if (response.data.config.count.total > 0) {
            vm.flightResults.push(response.data)
          } else {
            vm.noResults = true
          }
        })
        .then(function() {
          vm.backgroundImagePath = vm.getImage(
            [
              vm.flightResults[0].data.airports[
                vm.flightResults[0].data.tripsets[
                  Object.keys(vm.flightResults[0].data.tripsets)[0]
                ].in_orig
              ].lon,
              vm.flightResults[0].data.airports[
                vm.flightResults[0].data.tripsets[
                  Object.keys(vm.flightResults[0].data.tripsets)[0]
                ].in_orig
              ].lat
            ],
            [
              vm.flightResults[0].data.airports[
                vm.flightResults[0].data.tripsets[
                  Object.keys(vm.flightResults[0].data.tripsets)[0]
                ].in_dest
              ].lon,
              vm.flightResults[0].data.airports[
                vm.flightResults[0].data.tripsets[
                  Object.keys(vm.flightResults[0].data.tripsets)[0]
                ].in_dest
              ].lat
            ]
          )
        })
        .then(function() {
          vm.flightOfferLoading = false
        })
    },
    customLabel({ name, values }) {
      return `${name} (${values.iata})`
    },
    getFallback(airport) {
      let vm = this
      vm.noResults = false
      // Set offer to loading
      vm.flightOfferLoading = true
      // Search for offer
      let configData = window.bananasHighlightsConfigData[0]
      configData.airport = [airport.values.iata]
      let flightData = flightSchema.setReturnFlightSchema(configData)
      axios
        .post('https://tm.holidaypirates.group/v1/search', flightData, {
          headers: ''
        })
        .then(function(response) {
          if (response.data.config.count.total > 0) {
            vm.selectedAirports = [airport]
            vm.flightResults.push(response.data)
          }
        })
        .then(function() {
          vm.flightOfferLoading = false
        })
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = false
        this.$store.dispatch('updateTrackingIsAllowed')
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.toString() !== '') {
          if (urlParams.has('bn-track')) {
            if (urlParams.get('bn-track') === '1') {
              this.trackingAllowed = true
              this.$store.dispatch('setTrackingIsAllowed')
            }
          }
        }
      }
    },
    scrollVisible() {
      if (this.trackingAllowed && !this.tracked) {
        this.checkOfferVisible()
      }
    },
    getBoundingClientRect(element) {
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    checkOfferVisible() {
      const pageCoordinates = this.getBoundingClientRect(this.$el.children[0])
      if (
        pageCoordinates.top >= 0 &&
        pageCoordinates.left >= 0 &&
        pageCoordinates.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        pageCoordinates.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      ) {
        let pageType = 'undefined'
        let pagePostId = 'undefined'
        if (window.dataLayer.length > 0) {
          if (window.dataLayer[0].hasOwnProperty('pageType')) {
            pageType = window.dataLayer[0].pageType
          }
          if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
            pagePostId = window.dataLayer[0].pagePostId
          }
        }
        try {
          const offer = this.flightLists[0].data
          const offerId = offer.ranks[0].items[0]
          window.dataLayer.push({
            event: 'promoView',
            category: 'dealPromotion',
            action: 'impression',
            label:
              'automated' +
              '|' +
              pagePostId +
              '|' +
              this.flightLists[0].config.adapter +
              '|flight|' +
              offerId, // for example 'unifiedSearch|flight'
            value: undefined,
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    id: offerId,
                    name:
                      'automated|' +
                      this.flightLists[0].config.adapter +
                      '|' +
                      pageType +
                      '|flight|' +
                      offer.tripsets[offerId].id,
                    creative:
                      offer.tripsets[offerId].out_orig +
                      '-' +
                      offer.tripsets[offerId].out_dest +
                      ':' +
                      offer.tripsets[offerId].in_orig +
                      '-' +
                      offer.tripsets[offerId].in_dest,
                    position: undefined
                  }
                ]
              }
            }
          })
        } catch (err) {}
        this.tracked = true
      }
    },
    trackClick() {
      window.dataLayer = window.dataLayer || []
      let pageType = 'undefined'
      let pagePostId = 'undefined'
      if (window.dataLayer.length > 0) {
        if (window.dataLayer[0].hasOwnProperty('pageType')) {
          pageType = window.dataLayer[0].pageType
        }
        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
          pagePostId = window.dataLayer[0].pagePostId
        }
      }
      try {
        const offer = this.flightLists[0].data
        const offerId = offer.ranks[0].items[0]
        window.dataLayer.push({
          event: 'promoClick',
          category: 'dealPromotion',
          action: 'conversion',
          label:
            'automated' +
            '|' +
            pagePostId +
            '|' +
            this.flightLists[0].config.adapter +
            '|flight|' +
            offerId, // for example 'unifiedSearch|flight'
          value: undefined,
          ecommerce: {
            promoClick: {
              promotions: [
                {
                  id: offerId,
                  name:
                    'automated|' +
                    this.flightLists[0].config.adapter +
                    '|' +
                    pageType +
                    '|flight|' +
                    offer.tripsets[offerId].id,
                  creative:
                    offer.tripsets[offerId].out_orig +
                    '-' +
                    offer.tripsets[offerId].out_dest +
                    ':' +
                    offer.tripsets[offerId].in_orig +
                    '-' +
                    offer.tripsets[offerId].in_dest,
                  position: undefined
                }
              ]
            }
          }
        })
      } catch (err) {}
      this.tracked = true
    },
    base64EncodeUnicode(str) {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
      const utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function(match, p1) {
          return String.fromCharCode('0x' + p1)
        }
      )

      return btoa(utf8Bytes)
    }
  },
  filters: {
    formatDate(rawDate) {
      // Example rawDate [2018-05-13T06:55:00, 'YYYY-MM-DD']
      let date = rawDate[0].split('T')
      return fecha.format(new Date(date[0]), rawDate[1])
    },
    formatTime(rawDateTime) {
      if (rawDateTime[0] !== '') {
        // Split String by T (example 2018-05-13T06:55:00)
        let time = rawDateTime[0].split('T')
        return fecha.format(
          fecha.parse(time[0] + ' ' + time[1], 'YYYY-MM-DD HH:mm'),
          rawDateTime[1]
        )
      } else {
        return ''
      }
    },
    calculateTravelTime(travelTime) {
      let hours = Math.floor(travelTime / 60)
      let minutes = travelTime % 60
      return hours + 'h ' + minutes + 'm'
    },
    showCabinOutput(cabinShortcut) {
      switch (cabinShortcut) {
        case 'Y':
          return 'Economy Class'
        case 'W':
          return 'Premium Ecomomy Class'
        case 'C':
          return 'Business Class'
        case 'F':
          return 'Firts Class'
        default:
          return ''
      }
    },
    formatPrice(price) {
      return parseFloat(price).toFixed(0)
    }
  }
}
</script>
